<template>
  <div
    class="-mx-12 p-12 flex flex-col lg:flex-row flex-wrap justify-between border-t border-purple-ap-t03"
  >
    <p class="w-full text-center my-5">
      <ChildCareHours class="text-3xl" :aupair="aupair" />
    </p>

    <div
      class="w-full flex flex-col lg:flex-row items-center justify-around text-center my-5"
    >
      <Nationality :birthCountry="aupair.birthCountry" />

      <Age :age="aupair.birthDate" />

      Gender: {{ aupair.gender == "F" ? "Female" : "Male" }}
    </div>

    <div
      class="w-full flex flex-col lg:flex-row items-center justify-around text-center my-5"
    >
      <InfantCareQualified :infantCareQualified="aupair.infantCareQualified" />
      <Driver :experiencedDriver="aupair.experiencedDriver" />
      <Swimmer :swimmer="aupair.swimmer" />
    </div>

    <div
      class="w-full flex flex-col lg:flex-row items-center justify-around text-center my-5"
    >
      <p>{{ aupair.englishProficiency }} English Proficiency</p>
      <FirstAvailableDate :date="aupair.firstAvailableDate" />
    </div>
  </div>
</template>

<script>
import ChildCareHours from "@/components/AuPairs/AuPairCardItems/ChildCareHours.vue";
import Nationality from "@/components/AuPairs/AuPairCardItems/Nationality.vue";
import Age from "@/components/AuPairs/AuPairCardItems/Age.vue";
import InfantCareQualified from "@/components/AuPairs/AuPairCardItems/InfantCareQualified.vue";
import Driver from "@/components/AuPairs/AuPairCardItems/Driver.vue";
import Swimmer from "@/components/AuPairs/AuPairCardItems/Swimmer.vue";
import FirstAvailableDate from "@/components/AuPairs/AuPairCardItems/FirstAvailableDate.vue";

export default {
  name: "FullSummary",
  props: {
    aupair: Object,
  },
  components: {
    ChildCareHours,
    Nationality,
    Age,
    InfantCareQualified,
    Driver,
    Swimmer,
    FirstAvailableDate,
  },
  computed: {
    age() {
      let birthYear = new Date(this.aupair.birthDate).getFullYear();
      let currentYear = new Date().getFullYear();
      return currentYear - birthYear;
    },
  },
};
</script>
